export enum GlobalModal {
  NewTickets = "redesign-new-tickets",
  OneTimeReportSended = "one-time-report-sended",
}
